<span #userWidgetRef class="user-widget">
  <span class="name">{{ user ? (initials ? user.initials : user.name) : '' }}</span>
</span>
